import { MeetingResponse } from 'lib/api/meetings/types';
import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import {
  mapToGTMMeetingAttributes,
  transformMeetingResponseToGTMAttributes,
} from './utils';
import { GTMMeetingAttributes, GTMMeetingInteractionAction } from './types';

export function meetingInteractionEvent({
  meetingResponse,
  livePageUrl,
  attendeeLimit,
  action,
}: {
  meetingResponse: MeetingResponse;
  livePageUrl: string;
  attendeeLimit: number;
  action: GTMMeetingInteractionAction;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.MEETING_INTERACTION,
  };

  const meetingAttributes = transformMeetingResponseToGTMAttributes(
    meetingResponse,
    livePageUrl,
    attendeeLimit
  );

  const gtmMeetingAttributes: GTMMeetingAttributes =
    mapToGTMMeetingAttributes(meetingAttributes);

  pushToDataLayer({
    ...eventAttributes,
    ...gtmMeetingAttributes,
    action: action,
  });
}
